module.exports = __webpack_public_path__ + "static/img/d11t_pc.60edd57b.jpg";